// extracted by mini-css-extract-plugin
module.exports = {"card":"widgetCard_card__rTqph","title":"widgetCard_title__xR1Tv","subTitle":"widgetCard_subTitle__IsgWp","heading":"widgetCard_heading__IAdxE","btn":"widgetCard_btn__PgtcL"};